import styled, { css } from 'styled-components';
import { StyledPageBody } from '../../Page.styled';

export const OverviewPageBody = styled(StyledPageBody)`
    ${({ isListView }) =>
        !isListView &&
        css`
            display: flex;
            flex-direction: column;
        `}
`;

export const OverviewGridArea = styled.div`
    flex: 1;
    min-height: 0;
`;
